module.exports = __webpack_public_path__ + "media/packs/images/flags/AO-49be4fef3d91694535ddd713484e8fa7.png";